export default __webpack_public_path__ + "static/media/NU.e199b046.svg";